module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon_quote_left-529682d02e37a59b50cf06c67d42e32b.svg";